import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { RULE_TIME_MODULO_VALUES } from 'yeself-common/enum/RuleEnum';

import SelectField from '../../components/SelectField';

import { TimeModuloRuleValues } from '../types';

type TimeModuloRuleFieldProps = {
    value: TimeModuloRuleValues;
    onChange: (value: TimeModuloRuleValues) => void;
};

const TimeModuloRuleField = ({ value, onChange }: TimeModuloRuleFieldProps): React.ReactElement => {
    const [levelValue, setLevelValue] = useState({
        level0: value.level?.[0]?.data.key || null,
    });

    const handleOnChange = useCallback(
        (index: number) => (newValue) => {
            const newLevelValue = { ...levelValue, [`level${index}`]: newValue };

            const level: TimeModuloRuleFieldProps['value']['level'] = [
                newLevelValue.level0 ? { data: { key: newLevelValue.level0 } } : undefined,
            ];

            setLevelValue(newLevelValue);
            onChange({ ...value, level });
        },
        [levelValue, onChange, value]
    );

    return (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            <SelectField
                autoWidth
                options={[
                    {
                        label: <FormattedMessage id="Rules.level.timeModulo.A" />,
                        value: RULE_TIME_MODULO_VALUES.A,
                    },
                    {
                        label: <FormattedMessage id="Rules.level.timeModulo.B" />,
                        value: RULE_TIME_MODULO_VALUES.B,
                    },
                ]}
                value={levelValue.level0 || ''}
                onChange={handleOnChange(0)}
            />
        </>
    );
};

export default TimeModuloRuleField;
